import { LegalDocumentProvider } from "../LegalDocumentProvider";
import { ApiClientFactory } from "./clients";

export class LegalDocumentProviderFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/legal-document`
    );
  }

  createLegalDocumentProvider(): LegalDocumentProvider {
    return new LegalDocumentProvider(this.apiClientFactory.createApiClient());
  }
}
